import React from 'react';
import Grid from '@material-ui/core/Grid';
import { Typography } from '@material-ui/core';
import PropTypes from 'prop-types';
import teeth from '../../constants/teeth';
import Tooth from '../RxForm/IDB/Teeth/Tooth';

const Teeth = ({ hideSectionLabels, size, commonToothProps, toothPropsGenerator }) => {
  const overrideToothProps = {
    ...commonToothProps
  };

  switch (size) {
    case 'small':
      overrideToothProps.size = 32;
      overrideToothProps.fontSize = 10;
      break;
    case 'medium':
      overrideToothProps.size = 48;
      overrideToothProps.fontSize = 12;
      break;
    case 'large':
      break;
    default:
  }

  const generateTeeth = part => {
    return teeth
      .filter(({ name }) => name.startsWith(part))
      .sort()
      .map(({ name, icon }) => {
        let toothProps = {
          ...overrideToothProps,
          label: size === 'small' ? name.substring(1) : name,
          value: name,
          image: icon
        };

        if (toothPropsGenerator) {
          toothProps = { ...toothPropsGenerator(name, toothProps) };
        }

        return (
          <Grid key={name} item>
            <Tooth {...toothProps} />
          </Grid>
        );
      });
  };

  return (
    <div>
      {!hideSectionLabels && (
        <Grid container direction="row" justifyContent="space-between" alignItems="center">
          <Grid item xs>
            <Typography variant="subtitle1" gutterBottom align="left">
              Upper Right
            </Typography>
          </Grid>
          <Grid item xs>
            <Typography variant="subtitle1" gutterBottom align="center">
              Maxillary
            </Typography>
          </Grid>
          <Grid item xs>
            <Typography variant="subtitle1" gutterBottom align="right">
              Upper Left
            </Typography>
          </Grid>
        </Grid>
      )}
      <Grid container justifyContent="center" spacing={0}>
        {generateTeeth('U')}
      </Grid>
      <Grid container justifyContent="center" spacing={0}>
        {generateTeeth('L')}
      </Grid>
      {!hideSectionLabels && (
        <Grid container direction="row" justifyContent="space-between" alignItems="center">
          <Grid item xs>
            <Typography variant="subtitle1" gutterBottom align="left">
              Lower Right
            </Typography>
          </Grid>
          <Grid item xs>
            <Typography variant="subtitle1" gutterBottom align="center">
              Mandibular
            </Typography>
          </Grid>
          <Grid item xs>
            <Typography variant="subtitle1" gutterBottom align="right">
              Lower Left
            </Typography>
          </Grid>
        </Grid>
      )}
    </div>
  );
};

Teeth.propTypes = {
  hideSectionLabels: PropTypes.bool,
  size: PropTypes.string,
  // eslint-disable-next-line react/forbid-prop-types
  commonToothProps: PropTypes.object,
  toothPropsGenerator: PropTypes.func
};

Teeth.defaultProps = {
  hideSectionLabels: false,
  size: 'large',
  commonToothProps: {},
  toothPropsGenerator: null
};

export default Teeth;
